function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Breakpoint = /*#__PURE__*/function () {
  function Breakpoint(el) {
    var _this = this;
    _classCallCheck(this, Breakpoint);
    this.container = el;
    this.breakpoint = {};
    this.children = this.getChildren();
    this.observer = new ResizeObserver(function () {
      return _this.toggleClass();
    });
    this.observer.observe(this.container);
    if (this.container.getAttribute('data-breakpoint') !== '') {
      setTimeout(function () {
        return _this.init();
      }, 5);
    } else {
      console.warn('Please add a classname to the data-breakpoint attribute');
    }
  }
  _createClass(Breakpoint, [{
    key: "toggleClass",
    value: function toggleClass() {
      for (var key in this.breakpoint) {
        this.container.offsetWidth >= this.breakpoint[key] ? this.container.classList.remove("js-breakpoint-".concat(key)) : this.container.classList.add("js-breakpoint-".concat(key));
      }
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;
      var childHolder = {};
      var allChildren = _toConsumableArray(this.container.querySelectorAll('[data-breakpoint-watch]'));
      var identifiers = this.container.getAttribute('data-breakpoint').split(',');
      identifiers.forEach(function (ID) {
        _this2.breakpoint[ID] = 250;
        childHolder[ID] = [];
        allChildren.forEach(function (child) {
          if (child.getAttribute('data-breakpoint-watch').indexOf(ID) > -1) childHolder[ID].push(child);
        });
      });
      return childHolder;
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      var _loop = function _loop(key) {
        _this3.children[key].forEach(function (child) {
          _this3.breakpoint[key] += child.offsetWidth;
          _this3.breakpoint[key] += parseInt(window.getComputedStyle(child).marginLeft);
          _this3.breakpoint[key] += parseInt(window.getComputedStyle(child).marginRight);
        });
      };
      // Create the breakpoint
      for (var key in this.children) {
        _loop(key);
      }
      this.container.classList.add('js-breakpoint');
    }
  }]);
  return Breakpoint;
}();
export { Breakpoint as default };